package one.devsbox.www.ui.users.activity

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.ads.TargetType
import one.devsbox.shared.ads.UserAction
import one.devsbox.www.io.Repository
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class UsersActivityVM : NavigationViewModel() {
    private lateinit var ctx: UsersActivityCtx

    var state by mutableStateOf<DataState<SharedIO.UserActivities>>(DataState.Loading())
        private set

    var loadingMore by mutableStateOf(false)
        private set

    val search = TextFieldState()
    val selectedActions = mutableStateListOf<UserAction>()
    var selectedTarget by mutableStateOf<TargetType?>(null)

    interface Action {
        fun toggleAction(action: UserAction)
        fun setTarget(target: TargetType?)
        fun loadMore()
        fun back()
        fun reload()
    }

    val action = object : Action {
        override fun toggleAction(action: UserAction) {
            if (selectedActions.contains(action)) {
                selectedActions.remove(action)
            } else {
                selectedActions.add(action)
            }
            loadPage(0)
        }

        override fun setTarget(target: TargetType?) {
            selectedTarget = target
        }

        override fun loadMore() {
            val current = state.entry ?: return
            if (!loadingMore && current.items.size < current.count) {
                loadPage(current.page + 1)
            }
        }

        override fun back() {
            ctx.nav.up()
        }

        override fun reload() {
            loadPage(0)
        }
    }

    fun setup(ctx: UsersActivityCtx) {
        this.ctx = ctx
        if (state is DataState.Loading) {
            loadPage(0)
        }
    }

    private fun loadPage(page: Int = 0) {
        if (page == 0) {
            state = DataState.Loading(state.entry)
        } else {
            loadingMore = true
        }

        val mask = if (selectedActions.isEmpty()) {
            UserAction.entries.sumOf { it.mask }
        } else {
            selectedActions.sumOf { it.mask }
        }

        scope.launch {
            runCatching {
                Repository.ads.user.activity(ctx.args.id, page, mask)
            }.onSuccess { response ->
                if (page == 0) {
                    state = DataState.Result(response)
                } else {
                    val current = (state as? DataState.Result)?.nnvl
                    if (current != null) {
                        state = DataState.Result(
                            current.copy(
                                page = response.page,
                                items = current.items + response.items
                            )
                        )
                    }
                }
                loadingMore = false
            }.onFailure {
                if (page == 0) state = DataState.Error(it.message ?: "Failed to fetch activities")
                loadingMore = false
            }
        }
    }

    override fun onRelease() {}
}
